<template>
    <div class="scroll-content-horizonal section-custom" ref="scrollContent">
        <MemberNode 
            v-for="(item, index) in data"
            :key="index"
            :data="item"
            @handleChecked="handleChecked" />
        <Empty v-if="!data.length"/>
    </div>
</template>
<script>
    import MemberNode from './section-member-node'
    import scroll from '../mixins/scroll'
    import section from '../mixins/section'
    import Empty from '../../../base/empty/'

    export default {
        name: 'SectionMember',
        mixins: [scroll, section],
        props: {
            data: {
                type: Array,
                default: function() {
                    return []
                }
            }
        },
        components: {
            MemberNode,
            Empty
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/business/select-member/section/section-custom.vue